



$(document).ready(function (e) {
  
    


// Home page slider
var $wrapperSlider = $('.homeslider_list'),
wrapperSlider = $wrapperSlider[0];

if ($(window).width() < 767) {
$('.homeslider_list').slick({
        dots: true,
        infinite: true,
		centerMode: false,
		variableWidth: false,
        draggable: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: false,  
});

$('.three_slider').slick({
        dots: true,
        infinite: true,
		centerMode: false,
		variableWidth: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        swipe: true,
       draggable: true
});
  
} else { 
  
  $('.homeslider_list').slick({
        dots: true,
        infinite: true,
		centerMode: false,
		variableWidth: false,
        draggable: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,  
});
$('.three_slider').slick({
        dots: true,
        infinite: false,
		centerMode: false,
		variableWidth: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipe: true,
       draggable: false
});

  
}




$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $(".sitelogo").addClass("active");
      $("header-section").addClass("show_header");
       $(".Announcement-bar-section").addClass("show_announcement");
      
    } else {
        $(".sitelogo").removeClass("active");
      $("header-section").removeClass("show_header");
      $(".Announcement-bar-section").removeClass("show_announcement");
    }
  
});
  

});


$(function(){
	 var $animation_elementss = $('.footer-logo'),
    $window = $(window),
    scrollTop = $(window).scrollTop();

    function check_if_in_views() {
        var window_height = $(window).height();
        var window_top_position = $(window).scrollTop();
        var window_bottom_position = $(window).scrollTop() + $(window).height();

        $.each($animation_elementss, function () {
            var $element = $(this);
            var element_height = $element.outerHeight();
            var element_top_position = $element.offset().top;
            var element_bottom_position = (element_top_position + element_height);
             if ((element_bottom_position > window_top_position) && element_top_position < window_bottom_position && window_top_position > scrollTop) {
		        $('.sitelogo').addClass("hide_logo");

            } else if((element_bottom_position > window_top_position) && element_top_position < window_bottom_position && window_top_position < scrollTop) {
                $('.sitelogo').addClass("hide_logo");
            } else {
                 $('.sitelogo').removeClass("hide_logo");

            }
        });
    }
		$(window).on('scroll' , () => {
        check_if_in_views();
        scrollTop = $(window).scrollTop();
    })
    });
  //end


